import {cva} from 'class-variance-authority'

/**
 * TableCell variants (CVA). Padding follows MUI's `padding` prop crossed with the
 * table `size`; `normal` medium = 16px (the Figma 56px row), `small` = 6px
 * vertical, `checkbox` = the tight 4px gutter for a leading selection cell.
 */
export const TableCellVariantsFactory = cva(
  'border-b border-divider align-middle text-[1rem] leading-[1.2] tracking-[0.15px]',
  {
    variants: {
      variant: {
        head: 'font-bold text-text-primary',
        body: 'font-normal text-text-primary',
        footer: 'border-b-0 font-normal text-[0.875rem] text-text-secondary',
      },
      align: {
        inherit: '',
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
        justify: 'text-justify',
      },
      padding: {
        normal: '',
        checkbox: 'w-12 px-1 py-0',
        none: 'p-0',
      },
      size: {
        small: '',
        medium: '',
      },
    },
    compoundVariants: [
      {padding: 'normal', size: 'medium', className: 'px-4 py-4'},
      {padding: 'normal', size: 'small', className: 'px-4 py-1.5'},
    ],
    defaultVariants: {
      variant: 'body',
      align: 'inherit',
      padding: 'normal',
      size: 'medium',
    },
  },
)
